import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6tmqj9f90u: FaireBrandEntity = {
  token: "b_6tmqj9f90u",
  type: "brand",
  name: "fabdog",
  avatarUrl:
    "https://cdn.faire.com/fastly/04a22a20707ea452cdecdc7a48167e69a0e1e9da5d0a2a6cc7ea2f80fc8d6883.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/9fb56beb9146f73e98105f8b08810ae0d79395570e0c460cea724ca61fed8fa4.png",
  logoUrl:
    "https://cdn.faire.com/fastly/04a22a20707ea452cdecdc7a48167e69a0e1e9da5d0a2a6cc7ea2f80fc8d6883.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/9fb56beb9146f73e98105f8b08810ae0d79395570e0c460cea724ca61fed8fa4.png",
  location: "Lodi, NJ, USA",
  minimumOrderDollars: 207,
  rating: 4.9,
  reviewCount: 199,
  isInsider: true,
  description:
    "Started in New York City in 2002 by founder and designer Cassie Cole – fabdog® was created with one mission in mind: to make human quality apparel and accessories that can make any dog a fabdog®.\n\nAt the heart of everything we do is a dedication to excellence. Our relentless pursuit of quality ensures that every product, interaction, and experience reflects the highest standards of craftsmanship and reliability. From meticulous design details to our unwavering commitment, we strive for nothing less than perfection. This dedication drives us to continually innovate and exceed your expectations.\nfabdog®’s promise: to dress your dog in quality clothing that’s both comfortable and stylish.\n\nWhen playtime rolls around, we believe that the best pets deserve the very best toys. That’s why our toys are crafted with intention and care. Understanding that each pet has unique preferences, we've developed a variety of lines to cater to every whim and ensure your furry friend finds their perfect playmate.\n\nWe understand that a special bond exists between humans and their pets. We have a true passion for what we do and it is reflected in our products. Our dedication for creating exceptional products ensures that every detail is perfected, delivering outstanding results for pets and their people. The fabdog® brand is Made for Dogs, Loved by Humans. \n",
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:35:48.773Z",
    importedBy: "entity-db-cli",
  },
};
